import { MobileIcon } from 'shared-widget-components/src/components/Icons';
import { formatHufPrice } from 'shared-widget-components/src/utils/FormatPrice';

/**
 * Event price component
 * this component is responsible for rendering the event price
 * @param {number[]} price - price of the event
 * @returns EventPrice component
 */

export const EventPrice = ({ price }: { price: number[] }) => {
  if (!price || price.length === 0) return <></>;

  const minPrice = Math.min(...price);

  const formattedPrice = formatHufPrice(minPrice);

  return (
    <div className='min-[350px]:hidden sm:flex gap-2 items-center justify-start min-[350px]:mb-1 min-[1200px]:mb-2'>
      <MobileIcon />
      <p className='text-[14px] leading-[24px] font-semibold font-body'>{formattedPrice}-tól</p>
    </div>
  );
};
